import { Button } from '../primitives';

/**
 * Nabídka obnovení rozpracovaného konceptu (viz `useDocDraft`).
 *
 * Zobrazí se nad formulářem, když se při otevření prázdného dokumentu najde
 * v prohlížeči automaticky uložený koncept. „Obnovit" předvyplní formulář,
 * „Zahodit" koncept smaže.
 */
export interface DraftBannerProps {
  savedAt: number;
  onRestore: () => void;
  onDiscard: () => void;
}

function relativeTime(ts: number): string {
  if (!ts) return '';
  const diff = Date.now() - ts;
  const min = Math.round(diff / 60000);
  if (min < 1) return 'před chvílí';
  if (min < 60) return `před ${min} min`;
  const hod = Math.round(min / 60);
  if (hod < 24) return `před ${hod} h`;
  try {
    return new Date(ts).toLocaleString('cs-CZ');
  } catch {
    return '';
  }
}

export function DraftBanner({ savedAt, onRestore, onDiscard }: DraftBannerProps) {
  const when = relativeTime(savedAt);
  return (
    <div
      role="status"
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 12,
        margin: '0 0 16px',
        padding: '12px 16px',
        borderRadius: 8,
        background: 'var(--sd-yellow-soft)',
        border: '1px solid var(--sd-yellow-border)',
        color: 'var(--sd-yellow-ink)',
      }}
    >
      <span aria-hidden style={{ fontSize: 18, lineHeight: 1 }}>
        ✎
      </span>
      <div style={{ flex: '1 1 240px', fontSize: 14, lineHeight: 1.4 }}>
        <strong>Nalezen rozpracovaný koncept</strong>
        {when ? <span style={{ opacity: 0.85 }}> — automaticky uložen {when}.</span> : '.'}{' '}
        Chcete v něm pokračovat?
      </div>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <Button size="sm" variant="primary" onClick={onRestore}>
          Obnovit
        </Button>
        <Button size="sm" variant="ghost" onClick={onDiscard}>
          Zahodit
        </Button>
      </div>
    </div>
  );
}
